import ExamsRoute from './ExamsRoute';

export default {
  name: 'ExamsRoute',
  location: '/exams',
  component: ExamsRoute,
};
